import apiCaller from 'services/Api/ApiCaller';
import { API_URL } from 'settings';
import {
  NotionalLimitSettingsResponse,
  SessionUnderlyingAssetNotionalLimit,
} from 'state';

export type NotionalLimitDraftPayload = {
  session_id: number;
  instrument_limit_mode: 0 | 1;
  underlying_assets: number[];
  notional_limits: SessionUnderlyingAssetNotionalLimit[];
  include_sector_alpha_settings?: false;
};

const errorMessage = (result: unknown): string => {
  if (typeof result === 'string' && result) return result;
  if (result && typeof result === 'object') {
    return JSON.stringify(result);
  }
  return 'The instrument-limit draft could not be saved.';
};

/** Persist one complete draft snapshot. The caller serializes these requests. */
export const persistNotionalLimitDraft = async (
  payload: NotionalLimitDraftPayload,
): Promise<NotionalLimitSettingsResponse> => {
  const { result, status } = await apiCaller<NotionalLimitDraftPayload>({
    path: '/sessions/:session_id/update_notional_limit_settings',
    method: 'POST',
    data: payload,
    apiUrl: API_URL,
    // A final input blur commonly precedes Refresh. Allow that small authoring
    // write to finish while the browser unloads the page.
    keepalive: true,
  });
  if (status.toString()[0] !== '2') {
    throw new Error(errorMessage(result));
  }
  return result as NotionalLimitSettingsResponse;
};
